import(/* webpackMode: "eager" */ "/codebuild/output/src2116344597/src/rmh-platform/apps/rmh-patient/app/error.tsx");
